<template>
    <div class="header">
        <img class="img-responsive logo-header" src="static/img/Logo-EPM2.png">
        <img class="img-responsive logo-header" src="static/img/Logo-Emtelco2.png">
        <img class="img-responsive pull-right logo-header" src="static/img/Logo2.png">
    </div>
</template>

<script>
export default{
    name: 'emt-header'
}
</script>



// WEBPACK FOOTER //
// emt-header.vue?1dd347cf